<template>
  <div
    class="table-row-holder"
    :class="{'selected': checked}">
    <div
      class="custom-table-row c-float">
      <!-- CHECKBOX -->
      <div v-if="checkbox && !listItem.is_shared_shipment" class="checkbox-cell">
        <Checkbox
          v-model="checked"
          @change="onChange" />
      </div>

      <div class="data-cell" @click="rowAction">
        <div class="top-row flex">
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(listItem.ship_date, 'shipment') }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ listItem.sender_city }}</span>
              <span class="align-middle">{{ `, ${listItem.sender_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ listItem.sender_company_name ||  listItem.sender_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef' }"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRef">
                  <p v-if="listItem.sender_company_name">{{ listItem.sender_company_name }}</p>
                  <p v-if="listItem.sender_name">{{ listItem.sender_name }}</p>
                  <p v-if="listItem.sender_address_1">{{ listItem.sender_address_1 }}</p>
                  <p v-if="listItem.sender_address_2">{{ listItem.sender_address_2 }}</p>
                  <p v-if="listItem.sender_post_code || listItem.sender_city">{{ `${listItem.sender_post_code} ${listItem.sender_city}` }}</p>
                  <p v-if="listItem.sender_state">{{ listItem.sender_state }}</p>
                  <p v-if="listItem.sender_country_id">{{ countryName(listItem.sender_country_id) }}</p>
                  <p v-if="listItem.sender_phone">{{ `${listItem.sender_phone}` }}</p>
                  <p v-if="listItem.sender_email">{{ listItem.sender_email }}</p>
                </div>
              </span>
            </p>
          </div>
          <div class="middle-box status-box">
            <div
              class="shipment-status-bar"
              :class="statusInfo.class">
              <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="0" x2="100%" y2="0" />
              </svg>
              <div class="icon-point">
                <p class="status-text">{{ $t(statusInfo.text) }}</p>
                <Icon
                  :name="statusInfo.icon"
                  size="15" />
              </div>
              <div class="point-one"></div>
              <div class="point-two"></div>
            </div>
            <p class="update-info">
              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(listItem.shipment_status_date, 'shipment_last_update')}` }} </span> |
              {{ getStatusMessageText(listItem.shipment_status_message) }}
            </p>
          </div>
          <div class="info-box fix-width-position">
            <div class="date-section">
              <p class="small-text date-display">
                <span :class="listItem.actual_eta ? 'strikethrough' : ''">{{ formatDate(listItem.eta, 'shipment') }}</span>
                <span v-if="listItem.actual_eta">
                  <span class="date-arrow"> > </span>
                  <span class="actual-eta">{{ formatDate(listItem.actual_eta, 'shipment') }}</span>
                </span>
              </p>
            </div>
            <p class="big-text">
              <span class="cut-text medium">{{ listItem.customer_address_city }}</span>
              <span class="align-middle">{{ `, ${listItem.customer_address_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ listItem.customer_address_company_name || listItem.customer_address_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRefCustomer' }"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRefCustomer">
                  <p v-if="listItem.customer_address_company_name">{{ listItem.customer_address_company_name }}</p>
                  <p v-if="listItem.customer_address_name">{{ listItem.customer_address_name }}</p>
                  <p v-if="listItem.customer_address_address_1">{{ listItem.customer_address_address_1 }}</p>
                  <p v-if="listItem.customer_address_address_2">{{ listItem.customer_address_address_2 }}</p>
                  <p v-if="listItem.customer_address_post_code || listItem.customer_address_city">{{ `${listItem.customer_address_post_code} ${listItem.customer_address_city}` }}</p>
                  <p v-if="listItem.customer_address_state">{{ listItem.customer_address_state }}</p>
                  <p v-if="listItem.customer_address_country_id">{{ countryName(listItem.customer_address_country_id) }}</p>
                  <p v-if="listItem.customer_address_phone">{{ `${listItem.customer_address_phone}` }}</p>
                  <p v-if="listItem.customer_address_email">{{ listItem.customer_address_email }}</p>
                </div>
              </span>
            </p>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="bottom-row flex">
          <div class="info-box inf-abs c-float w-33">
            <LogosSVG :name="listItem.shipping_agent_name" size="45" class="icon-left m-r-15" />
            <div class="text-left">
              <div v-if="!listItem.internal_tracking_link && !listItem.tracking_link">
                <p class="big-info-text">
                  <span class="m-r-5">{{ listItem.trace_no }}</span>
                </p>
                <p class="small-info-text">{{ listItem.shipping_agent_name }}</p>
<!--                <p class="small-text tooltip-holder">-->
<!--                  <span class="cut-text small">{{listItem.shipping_agent_name}}</span>-->
<!--                  <span class="d-inline-block info-tooltip">-->
<!--                <Icon-->
<!--                  v-tooltip="{ ref: 'tooltipCustomerService'}"-->
<!--                  name="info"-->
<!--                  size="15" />-->
<!--                <div class="info-tooltip-window" ref="tooltipCustomerService">-->
<!--                  <p>{{ `${$t('customer_service')}` }}</p>-->
<!--                  <p v-if="listItem.agent_customer_service_email && !listItem.custom_carrier">{{ listItem.agent_customer_service_email}}</p>-->
<!--                  <p v-else-if="listItem.custom_carrier_customer_service_email">{{listItem.custom_carrier_customer_service_email}}</p>-->
<!--                  <p v-if="listItem.agent_customer_service_phone && !listItem.custom_carrier">{{ listItem.agent_customer_service_phone}}</p>-->
<!--                  <p v-else-if="listItem.custom_carrier_customer_service_phone">{{listItem.custom_carrier_customer_service_phone}}</p>-->
<!--                </div>-->
<!--                </span>-->
<!--                </p>-->
              </div>
              <div v-else>
                <p class="big-info-text">
                  <span class="m-r-5 color-brend shipment-tracking-link" @click.stop="linkCall(listItem.internal_tracking_link ? listItem.internal_tracking_link : listItem.tracking_link)">{{ listItem.trace_no }} <Icon class="d-inline-block align-middle color-brand" name="link" size="14" /></span>
                </p>
                <p class="small-info-text">{{ listItem.shipping_agent_name }}</p>
              </div>
            </div>
          </div>
          <div class="middle-box c-float w-33">
            <Icon
              :circle=true
              name="hashMark"
              size="17"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ `Sender ref: ${listItem.sender_reference || '-'}` }}</p>
              <p class="small-info-text">{{ `Receiver ref: ${listItem.receiver_reference || '-'}` }}</p>
            </div>
          </div>
          <div class="info-box fix-width-position inf-abs c-float w-33 max-w-225">
            <Icon
              :circle=true
              :key="`iconKey-${randomNumber()}`"
              :name="goodTypeName(listItem.goods_type_prioritized).icon"
              size="20"
              class="icon-left m-r-15" />
            <div class="text-left">
              <p class="big-info-text">{{ listItem.shipping_product_name }}</p>
              <p class="small-info-text">{{ !goodsTypeText(listItem) ? goodTypeName(listItem.goods_type_prioritized).name : goodsTypeText(listItem) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import mixin from '@/mixins/mixins.js';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Btn from '@/components/elements/buttons';
import LogosSVG from "@/assets/images/logosSVG";
import date from '@/mixins/date'

export default {
  name: 'AllShipmentsRow',
  mixins: [mixin, date],
  components: {
    Checkbox, Btn, LogosSVG
  },
  props: [
    'checkbox',
    'checked',
    'listItem',
    'data',
    'rowActionParameter',
    'dropdown',
    'iconKey',
  ],
  data() {
    return {
      selected: false,
      isDropOpened: false,
    };
  },
  computed: {
    isCustomCarrier() {
      return !!this.listItem.custom_carrier_id;
    },
    statusInfo() {
      if(parseInt(this.listItem.status) === 34){
        return {
          class: 'step1',
          icon: 'clock',
          text: 'Waiting for approval',
        };
      } else if(parseInt(this.listItem.status) === 35){
        return {
          class: 'step1',
          icon: 'checkMan',
          text: 'Approved by carrier',
        };
      } else if(parseInt(this.listItem.status) === 3){
        return {
          class: 'step1',
          icon: 'printer',
          text: 'Booked',
        };
      } else if (parseInt(this.listItem.status) === 23) {
        return {
          class: 'step1',
          icon: 'ban',
          text: 'Waiting for departure',
        };
      } else if(parseInt(this.listItem.status) === 5) {
        return {
          class: 'step1',
          icon: 'deleteForever',
          text: 'canceled',
        };
      } else if(
        parseInt(this.listItem.status) === 4 ||
        parseInt(this.listItem.status) === 13 ||
        parseInt(this.listItem.status) === 17 ||
        parseInt(this.listItem.status) === 12) {
        return {
          class: 'step2',
          icon: 'delivery',
          text: 'transit',
        };
      } else if(parseInt(this.listItem.status) === 16) {
        return {
          class: 'step3',
          icon: 'warning',
          text: 'Deviation',
        };
      } else if (parseInt(this.listItem.status) === 15) {
        return {
          class: 'step3-pickup',
          icon: 'pin',
          text: 'In Pickup Point',
        };
      } else if(parseInt(this.listItem.status) === 6) {
        return {
          class: 'step3',
          icon: 'reply',
          text: 'Return_1',
        };
      } else if(parseInt(this.listItem.status) === 14 ) {
        return {
          class: 'step4',
          icon: 'check',
          text: 'Delivered',
        };
      }
    },
  },
  methods: {
    goodsTypeText(shipment) {
      if (!shipment.additional_info_array.goods_type_info) {
        return false;
      }

      const goodsTypeInfo = shipment.additional_info_array.goods_type_info;

      return Object.entries(goodsTypeInfo)
        .map(([type, count]) => `${count} x ${this.$t(type)}`)
        .join(', ');
    },
    getStatusMessageText(message) {
      //Translate first index of array
      if (message && message.includes('@separator0@')) {
        const statusMsgArray = message.split('@separator0@');
        return `${this.$t(statusMsgArray[0])} ${statusMsgArray[1]}`;
      }

      if (message && message.includes('#')) {
        const statusMsgArray = message.split('#');
        const translationString = statusMsgArray[0] ? statusMsgArray[0].trim() : '';
        return `${this.$t(translationString)} #${statusMsgArray[1]}`;
      }

      return `${this.$t(message)}`
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    rowAction() {
      this.$router.push(`/view-shipment/${this.listItem.id}`);
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    onChange() {
      this.$emit('updateSelect', this.listItem.id);
    },
    goodTypeName(type) {
      if(parseInt(type) === 1) {
        return {
          name: this.$t('parcel'),
          icon: 'savedItems',
        };
      }
      if(parseInt(type) === 2){
        return {
          name: this.$t('document'),
          icon: 'documentGoods',
        };
      }
      if(parseInt(type) === 3){
        return {
          name: this.$t('pallet'),
          icon: 'pallet',
        };
      }
      if(parseInt(type) === 4){
        return {
          name: this.$t('load'),
          icon: 'delivery',
        };
      }
    },
    linkCall(val) {
      window.open(val, '_blank');
    },
  },
}
</script>
